
import {getWithdrawalsUser} from '../api/getWithdrawalsUser';
import {setGetWithdrawalsUserAction} from '../action';
import { setLoadingAction } from '../../../components/templatePage/store/action';

const setGetWithdrawalsUser = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getWithdrawalsUser(params);
            
            if (data.status === 'success') {
                const getArrayMap = (value) => {
                    
                    const tmp = [];
                    if (value.length) {
                        for (let i = 0; i < value.length; i++) {
                            if ((i < value.length - 1) && +value[i].event_date === +value[i + 1].event_date)  {
                                tmp.push([{...value[i]}, {...value[i + 1]}])
                                i++;
                            } else {
                                tmp.push(value[i])
                            }
                        }
                    }   
                    return tmp
                }

                const prev = getArrayMap(getState().usersMobile.user_widthdrawals.data)
                const withdrawals = [];
                withdrawals.push(prev);

                withdrawals.push(getArrayMap(data.data));
                dispatch(setGetWithdrawalsUserAction({
                    data: withdrawals.flat(1),
                    countPage: data.count
                }));      
                dispatch(setLoadingAction(false))     
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetWithdrawalsUser
}